import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
import { scrollToSection } from '../utils/scrollToSection';
import '../styles/faq.css';

const FAQ = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: '¿Cuánto tiempo tarda una reforma integral?',
      answer:
        'El tiempo depende del tamaño y complejidad del proyecto. Una reforma de cocina o baño suele tardar entre 2-3 semanas, mientras que una vivienda completa puede requerir de 6 a 12 semanas. Siempre establecemos un calendario detallado antes de comenzar y nos comprometemos a cumplir los plazos acordados.',
    },
    {
      question: '¿Ofrecen garantía en los trabajos realizados?',
      answer:
        'Sí, todos nuestros trabajos incluyen garantía. La duración varía según el tipo de obra, como 2 años en reparaciones. Además, todos los materiales cuentan con la garantía del fabricante y nosotros actuamos como intermediarios para cualquier incidencia.',
    },
    {
      question: '¿Trabajan en toda la Costa Blanca?',
      answer:
        'Sí, trabajamos en toda la provincia de Alicante y la Costa Blanca, incluyendo Alicante ciudad, Benidorm, Torrevieja, Altea, Calpe, Denia, y todas las localidades intermedias. Nuestro equipo está distribuido estratégicamente para ofrecer un servicio rápido en cualquier zona.',
    },
    {
      question: '¿Cómo funciona el proceso de presupuesto?',
      answer:
        'Es muy sencillo: (1) Nos contactas por teléfono, email o formulario. (2) Concertamos una visita gratuita para evaluar el proyecto. (3) Te entregamos un presupuesto detallado por escrito en un plazo de 48-72 horas. (4) Si lo aceptas, acordamos fechas y comenzamos. Sin compromisos ni costes ocultos.',
    },
    {
      question: '¿Qué soluciones ofrecen para el agua dura de la zona?',
      answer:
        'La Costa Blanca tiene agua especialmente dura con alto contenido de cal. Ofrecemos varias soluciones: descalcificadores por intercambio iónico (ideales para toda la vivienda), sistemas de ósmosis inversa (agua de consumo), y filtros especializados. Realizamos un análisis gratuito del agua para recomendar la mejor opción.',
    },
  ];

  const scrollToContact = () => scrollToSection('contacto');

  return (
    <section id="faq" className="faq" ref={sectionRef}>
      <div className="faq-container">
        <motion.div
          className="faq-left"
          initial={{ opacity: 0, x: -50 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
          transition={{ duration: 0.8 }}
        >
          <span className="section-label">PREGUNTAS FRECUENTES</span>
          <h2 className="section-title">Resolvemos Tus Dudas</h2>
          <p className="faq-description">
            Encuentra respuestas a las preguntas más comunes sobre nuestros servicios. Si no encuentras lo que
            buscas, no dudes en contactarnos directamente.
          </p>
          <button className="btn-primary" onClick={scrollToContact}>
            CONTACTAR AHORA
          </button>
        </motion.div>

        <motion.div
          className="faq-right"
          initial={{ opacity: 0, x: 50 }}
          animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="faq-accordion">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <button
                  className={`faq-question ${openIndex === index ? 'active' : ''}`}
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span>{faq.question}</span>
                  <motion.div
                    className="faq-icon"
                    animate={{ rotate: openIndex === index ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Plus size={20} strokeWidth={2.5} />
                  </motion.div>
                </button>
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      className="faq-answer"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: 'easeInOut' }}
                    >
                      <div className="faq-answer-content">{faq.answer}</div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;